import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class SmsTemplateAPI {
  
  static list = (success, failure) => {
    fetch(Config.app.link + 'api/sms-template', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (template, success, failure) => {
    fetch(Config.app.link + 'api/sms-template', new Header('POST', template))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/sms-template/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default SmsTemplateAPI;